import {
  MonthViewOptions
} from '../models';

export const defaultMonthOptions: MonthViewOptions = {
  width: 7,
  height: 6
};
